import { jsx } from 'react/jsx-runtime';

/** ![removeFormattingIcon](data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgZmlsbD0ibm9uZSIgc3Ryb2tlPSIjMDAwIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiIHN0cm9rZS13aWR0aD0iMiI+PHJlY3QgZmlsbD0iI2ZmZiIgc3Ryb2tlPSIjZmZmIiB3aWR0aD0iMjQiIGhlaWdodD0iMjQiLz48cGF0aCBkPSJNNCA3VjRoMTZ2M001IDIwaDZNMTMgNCA4IDIwTTE1IDE1bDUgNU0yMCAxNWwtNSA1Ii8+PC9zdmc+) */
const removeFormattingIcon = /*#__PURE__*/jsx("path", {
  d: "M4 7V4h16v3M5 20h6M13 4 8 20M15 15l5 5M20 15l-5 5"
});

export { removeFormattingIcon };
